import { Component, HostListener } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import * as Global from 'src/app/global';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  PageMainTitle = Global.APP_NAME;
  title = 'callplaysports';

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private gtmService: GoogleTagManagerService,
  ) {}
  @HostListener('paste', ['$event']) blockPaste(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: KeyboardEvent) {
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: KeyboardEvent) {
    e.preventDefault();
  }
  // @HostListener('contextmenu', ['$event']) onRightClick(e: KeyboardEvent) {
  //   e.preventDefault();
  // }
  @HostListener('window:keydown.control.p', ['$event'])
  preventPrint(event: KeyboardEvent) {
    event.preventDefault();
  }
  // @HostListener('document:keydown', ['$event'])
  // handleKeyboardEvent(e: KeyboardEvent) {
  //   if (e.key === 'F12') {
  //     return false;
  //   } 
  //   if (e.key == 'PrintScreen') {
  //     alert('Print Screen was clicked')
  //     return false;
  //   }
  //   if (e.ctrlKey && e.shiftKey && e.key === "I") {
  //     return false;
  //   }
  //   if (e.ctrlKey && e.shiftKey && e.key === "C") {
  //     return false;
  //   }
  //   if (e.ctrlKey && e.shiftKey && e.key === "J") {
  //     return false;
  //   }
  //   if (e.ctrlKey && e.key == "U") {
  //     return false;
  //   }
  //   return true;
  // }
  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const gtmTag = {
          event: 'page',
          pageName: event.url
        };
        // console.log(gtmTag);
        this.gtmService.pushTag(gtmTag);
        const rt = this.getActivatedRouteChild(this.activatedRoute);
        rt.data.subscribe((data: any) => {
          if (data.pageTitle) {
            this.titleService.setTitle(
              data.pageTitle + ' - ' + this.PageMainTitle
            );
          } else {
            this.titleService.setTitle(this.PageMainTitle);
          }
        });
      }
    });
  }

  getActivatedRouteChild(activatedRoute: ActivatedRoute): ActivatedRoute {
    if (activatedRoute.firstChild) {
      return this.getActivatedRouteChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
